<template lang="pug">
BriqTable
  thead
    th Request Time
    th Method
    th URL
    th Status
    th 
  tbody
    template(v-for="item in logData")
      tr.audit-trail-data-col(@click="item.showDetals = !item.showDetals")
        td {{ prettyDate(item.RequestTimestampUtc) }}
        td {{ item.RequestMethod }}
        td {{ item.RequestUri }}
        td {{ item.ResponseStatusCode }}
        td 
          .show-detals-btn(:class="item.showDetals ? `rotate-180` : ``")
            BriqIcon(name="icon-input-arrow-down-icon")
      tr(v-if="item.showDetals")
        td(colspan="6") 
          .logs-details-table
            BriqTable
              tbody
                tr
                  td.title User
                  td {{ item.UserName }}
                  td.title Integration
                  td {{ item.ApiKeyIntegration }}
                tr
                  td.title Machine
                  td {{ item.Machine }}
                  td.title Instance
                  td {{ item.Instance }}
                tr
                  td.title IP
                  td {{ item.RequestIpAddress }}
                  td.title Deprecated
                  td {{ item.Deprecated }}
                tr
                  td.title Request
                  td {{ prettyDate(item.RequestTimestampUtc) }}
                  td.title Response
                  td {{ prettyDate(item.ResponseTimestampUtc) }}
                tr
                  td.title Headers
                  td {{ item.RequestContentHeaders }}
                  td.title Content Type
                  td {{ item.RequestContentType }}
                tr
                  td(colspan="2")
                    div {{ prettyDate(item.RequestTimestampUtc) }}
                    textarea(readonly) {{ item.RequestContentBody }}
                  td(colspan="2")
                    div {{ prettyDate(item.ResponseTimestampUtc) }}
                    textarea(readonly) {{ item.ResponseContentBody }}
            
</template>

<script>
import logTablesMixin from './logTablesMixin.js'

export default {
  name: 'ApiLogTable',
  mixins: [logTablesMixin],
  props: {
    logData: {
      type: Array,
      required: true,
    },
  },
}
</script>

<style scoped lang="stylus">
@import '~@v/components-global/BriqViewAuditTrail/tableStyle.styl';
</style>
